import { render, staticRenderFns } from "./Error404Page.vue?vue&type=template&id=718e8aec&scoped=true"
import script from "./Error404Page.vue?vue&type=script&lang=js"
export * from "./Error404Page.vue?vue&type=script&lang=js"
import style0 from "./Error404Page.vue?vue&type=style&index=0&id=718e8aec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718e8aec",
  null
  
)

export default component.exports